import React from "react";

export default function LoadingSkeleton({ isDark }) {
  
  return (
    <div
      className={`antialiased w-full overflow-hidden rounded-3xl ${
        isDark
          ? "bg-[#212121] border border-white-alpha-20"
          : "bg-white border border-black-alpha-15"
      }`}
      style={{ boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)" }}
    >
      <div className="flex flex-row items-center gap-8 p-16">
        <div
          className={`w-[29px] h-[29px] rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
        <div className="flex-1">
          <div
            className={`h-[23px] w-[180px] rounded-full animate-pulse ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
        {/* Count Badge Skeleton */}
        <div
          className={`w-[20px] h-[22px] rounded-sm animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
      </div>

      {/* History Items Skeleton */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className={`flex flex-row items-center px-16 py-12 gap-20 border-b ${
            isDark ? "border-white-alpha-05" : "border-[#0D0D0D]/5"
          }`}
        >
          <div className="flex-1 min-w-0">
            <div className="flex flex-col gap-8">
              {/* Text Preview Skeleton */}
              <div
                className={`h-[20px] w-full rounded-full animate-pulse ${
                  isDark ? "bg-grey-600" : "bg-grey-100"
                }`}
                style={{ maxWidth: i === 1 ? "90%" : i === 2 ? "85%" : "95%" }}
              />
              {/* Badge and Timestamp Skeleton */}
              <div className="flex items-center gap-14">
                {/* Human Badge Skeleton */}
                <div
                  className={`h-[24px] w-[80px] rounded-full animate-pulse ${
                    isDark ? "bg-grey-600" : "bg-grey-100"
                  }`}
                />
                {/* Timestamp Skeleton */}
                <div
                  className={`h-[16px] w-[70px] rounded-full animate-pulse ${
                    isDark ? "bg-grey-600" : "bg-grey-100"
                  }`}
                />
              </div>
            </div>
          </div>
          {/* Menu Button Skeleton */}
          <div
            className={`w-[23px] h-[23px] rounded animate-pulse flex-shrink-0 ${
              isDark ? "bg-grey-600" : "bg-grey-100"
            }`}
          />
        </div>
      ))}

      {/* Footer Actions Skeleton */}
      <div className="flex items-center justify-between pl-16 pr-8 py-8">
        <div
          className={`h-[24px] w-[100px] rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
        <div
          className={`h-[20px] w-[120px] rounded-full animate-pulse ${
            isDark ? "bg-grey-600" : "bg-grey-100"
          }`}
        />
      </div>
    </div>
  );
}
